export const iconFontAwesomeTimeHourglass = (
	<i className="fa-solid fa-hourglass"></i>
);
